import React, { FC, useContext, useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';

import { Button } from '@grupoboticario/flora-react';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SearchIcon from '@material-ui/icons/Search';

import sendClickEvent from 'src/services/googleAnalytics/helpers/sendClickEvent';

import Styled from './MobileHeaderStyled';

import { CatalogContext } from 'src/contexts/Catalog';

import { CatalogMenu } from '../../../../organisms/CatalogMenu';
import PageSelector from '../../../../organisms/PageSelector';
import { useStyle } from 'src/contexts/StyleContext';
import { Accessibility } from '@material-ui/icons';

export const MobileHeader: FC = () => {
  const [state] = useContext(CatalogContext);
  const [showPageSelector, setShowPageSelector] = useState(false);

  const { style } = useStyle();

  const router = useRouter();

  const goToLandingPage = () => {
    const landingPage = state.uf ? `/${state.uf.toLowerCase()}` : '/';
    router.push(landingPage);
  };

  const handleCloseClick = () => {
    goToLandingPage();
    sendClickEvent.goBack();
  };

  const searchLink = state.uf ? `/busca?uf=${state.uf}` : '/busca';

  const hidePageSelector = () => {
    setShowPageSelector(false);
  };

  return (
    <Styled.Wrapper aria-hidden={style.isProductDrawerOpen}>
      {showPageSelector ? (
        <Styled.PageSelectorWrapper>
          <PageSelector
            buttonVariant="conversion"
            hideSelector={hidePageSelector}
          />
          <Button
            className="cancel"
            type="submit"
            variant="ghost"
            size="small"
            aria-label="Cancelar mudança de página"
            onClick={hidePageSelector}
          >
            Cancelar
          </Button>
        </Styled.PageSelectorWrapper>
      ) : (
        <Styled.FlexContainer>
          <Styled.BackButtonWrapper>
            <Button
              label="Voltar"
              aria-label="Voltar"
              leftIcon={<ArrowBackIcon />}
              css={Styled.Button}
              onClick={handleCloseClick}
              data-testid="close-catalog"
            />
          </Styled.BackButtonWrapper>

          <Styled.Options>
            <Styled.RowReverse>
              <Link href="/acessibilidade" passHref>
                <Button
                  rightIcon={<Accessibility />}
                  label="Opções de acessibilidade"
                  aria-label="Opções de acessibilidade"
                  css={Styled.Button}
                  data-testid="go-to-accessibility"
                  onClick={sendClickEvent.goToAccessibilityOptions}
                />
              </Link>
              <Link href={searchLink} passHref>
                <Button
                  rightIcon={<SearchIcon />}
                  label="Ir para página de busca"
                  aria-label="Ir para página de busca"
                  css={Styled.Button}
                  data-testid="go-to-search"
                  onClick={sendClickEvent.search}
                />
              </Link>
            </Styled.RowReverse>
            <CatalogMenu />
          </Styled.Options>

          <Button
            type="submit"
            variant="ghost"
            size="small"
            aria-label={`Página ${state.page} de ${state.numberOfPages}. Clique para escolher outra página.`}
            onClick={() => setShowPageSelector(true)}
            data-testid="show-pageSelector"
            className="showSelector"
            css={{ order: 2 }}
          >
            {`${state.page}/${state.numberOfPages}`}
          </Button>
        </Styled.FlexContainer>
      )}
    </Styled.Wrapper>
  );
};
